module.exports = __webpack_public_path__ + "img/thumb.3f89bd55.png";